import React from 'react';
import { useParams, Navigate } from 'react-router-dom';

import {
  ROUTES,
  ROUTE_PARAMS,
  getProductRoute,
  interpolatePathParams,
  PREDICT_PRODUCT_SLUG,
  useLocalStorage
} from '@futrli/shared-services';

import { LOCAL_STORAGE_REDIRECT_KEY } from '../../constants';

/**
 * Send user back to the Import page if they've just re-authenticated with Google
 */
export const RedirectToImport = () => {
  const { organisationId: tempOrganisatioId, workspaceId: tempWorkspaceId, forecastId: tempForecastId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisatioId || '';
  const forecastId = tempForecastId || '';
  const [redirectUrl, , clearRedirectUrl] = useLocalStorage(LOCAL_STORAGE_REDIRECT_KEY, '');

  clearRedirectUrl();

  // if we have a redirect URL stored in local storage, use it
  if (redirectUrl) {
    return <Navigate to={redirectUrl} />;
  } else {
    // if not, redirect to to standard org forecast import page
    return (
      <Navigate
        to={interpolatePathParams(
          [getProductRoute(), ROUTES.FORECASTS, ROUTES.FORECAST_BY_ID, ROUTES.IMPORT].join(''),
          {
            [ROUTE_PARAMS.FORECAST_ID]: forecastId!,
            [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
            [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
            [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG
          }
        )}
      />
    );
  }
};
